import React, { useState, useEffect } from 'react'
import './news.css'

function News() {

    const [articles, setArticles] = useState([]);

    const fetchNews = async () => {
        const url = `https://newsapi.org/v2/top-headlines?category=business&q=crypto&apiKey=45325fcc718442fa9fc6b0689ee7e325`
        const data = await fetch(url);
        const parsedData = await data.json();
        console.log(parsedData.articles);
        setArticles(parsedData.articles);

    }

    useEffect(() => {
        fetchNews();

    }, [])

    function truncate(str, n) {
        return str?.length > n ? str.substr(0, n - 1) + "..." : str;
    }


    return (
        <div>
            <h1 id='newshead'>CryptoCurrency Top Headlines</h1>
            <div className="row">
                {articles.map((element) => {
                    return (<>
                        <div className="card newsCard" key={element.url}>
                            <img src={element.urlToImage ? element.urlToImage : "https://content.api.news/v3/images/bin/5007bd701af1b9f5402073862d4909bf"} className=" news_img" alt="..." />
                            <div className="card-body news_body">
                                <h5 className="card-title">{truncate(element.title, 40)}</h5>
                                <p className="card-text news_text">{truncate(element.description, 100)}</p>
                                <a href={element.url} className="btn btn-sm btn-primary">Read More</a>
                            </div>
                        </div>
                    </>)
                })}

            </div>
        </div>
    )
}

export default News